import { Alert, Heading, Text, VFlow } from 'bold-ui'
import { isEmpty } from 'lodash'
import React, { Fragment } from 'react'

import { NewsBalancedTopicsSection } from '../components/NewsBalancedTopicsSection'
import useNewsItems, { NewsVersion } from '../hooks/useNewsItems'

interface NewsInternalPanelProps {
  version: NewsVersion
}

export function NewsInternalPanel(props: Readonly<NewsInternalPanelProps>) {
  const newsItems = useNewsItems()
  const { version } = props
  const { title, internalTitle, topics, Panel, isEstabilizacao } = newsItems[version]

  if (!process.env.REACT_APP_VERSION) {
    return (
      <Alert type='danger' inline>
        Nenhuma informação sobre versões anteriores está disponível.
      </Alert>
    )
  }

  return (
    <Fragment>
      <Heading level={1} id={version}>
        {internalTitle ?? title}
      </Heading>
      <VFlow vSpacing={1}>
        {isEmpty(topics) ? (
          <Text>Nenhuma novidade por enquanto. Fique de olho neste espaço para futuras atualizações!</Text>
        ) : (
          <Fragment>
            {!isEstabilizacao && (
              <Fragment>
                <Text fontSize={0.875} fontWeight='bold'>
                  Novidades:
                </Text>
                <NewsBalancedTopicsSection topics={topics} textFontSize={0.875} />
              </Fragment>
            )}
            <VFlow vSpacing={1}>
              <Panel />
            </VFlow>
          </Fragment>
        )}
      </VFlow>
    </Fragment>
  )
}
